<div class="container">
  <div class="std-mg-top-4m std-ta-md-left std-ta-center">
    <div class="not-found-align">
      <h1>{{ "NOT_FOUND.TITLE" | translate }}</h1>
      <br />
      <br />
      <p nxHeadline="section" class="flush-mb-- not-found-label">
        {{ "NOT_FOUND.DESCRIPTION" | translate }}
      </p>
    </div>
  </div>
</div>
<br />
<br />
<br />
<br />
